import { createFileRoute } from '@tanstack/react-router';
import { AdminNewQuotePage } from '@/features/admin/admin-new-quote-page';

export const Route = createFileRoute('/admin/quotes/new')({
  component: AdminNewQuoteRoute,
});

function AdminNewQuoteRoute() {
  return <AdminNewQuotePage />;
}
